"use client"

import {
    Box,
    Button,
    Card,
    Heading,
    HStack,
    Icon,
    Popover,
    Portal,
    Skeleton,
    SkeletonText,
    Spinner,
    Text,
    VStack
} from "@chakra-ui/react";
import {
    FiCloudRain,
    FiThermometer,
    FiDroplet,
    FiSun,
    FiInfo
} from "react-icons/fi";
import React, {useState} from "react";
import {LineChart} from "../Charts";

const WeatherInformationE = ({cardBg, weather, loading, infoColor, weatherAnalysis, loadingAnalysis}) => {
    const [open, setOpen] = useState(false);

    const celsiusToFahrenheit = (c) => {
        if (c === null || c === undefined) return null;
        return ((c * 9) / 5 + 32).toFixed(1);
    };

    const mmToInches = (mm) => {
        if (mm === null || mm === undefined) return null;
        return (mm / 25.4).toFixed(2);
    };


    return (
        <Card.Root bg={cardBg} borderRadius="xl" h="full">
            <Card.Header>
                <Heading size="md">
                    <Icon as={FiCloudRain} mr={2} color="blue.500"/>
                    Weather Conditions
                </Heading>
            </Card.Header>
            <Card.Body>
                {loading ? (
                    <VStack spacing={6} align="start" w="full">
                        <HStack w="full" justifyContent="space-between">
                            <VStack align="start">
                                <SkeletonText noOfLines={1} width="100px"/>
                                <SkeletonText noOfLines={1} width="60px"/>
                            </VStack>
                            <VStack align="start">
                                <SkeletonText noOfLines={1} width="100px"/>
                                <SkeletonText noOfLines={1} width="60px"/>
                            </VStack>
                        </HStack>

                        <VStack align="start" w="full">
                            <SkeletonText noOfLines={1} width="200px"/>
                            <SkeletonText noOfLines={1} width="80px"/>
                            <Skeleton height="200px" w="full"/>
                        </VStack>

                        <VStack align="start">
                            <SkeletonText noOfLines={1} width="100px"/>
                            <SkeletonText noOfLines={1} width="120px"/>
                        </VStack>
                    </VStack>
                ) : (
                    <VStack spacing={4} align={"stretch"}>
                        <HStack w="full" justifyContent="space-between">
                            <HStack>
                                <Icon as={FiThermometer} color="red.500" boxSize={5}/>
                                <Box>
                                    <Text fontSize="sm" color="gray.500">Current Temperature</Text>
                                    {/*<Text fontWeight="bold">{weather?.clima?.temperatura}°C</Text>*/}
                                    <Text fontWeight="bold">
                                        {weather?.clima?.temperatura}°F
                                    </Text>

                                </Box>
                            </HStack>
                            <HStack>
                                <Icon as={FiDroplet} color="blue.500" boxSize={5}/>
                                <Box>
                                    <Text fontSize="sm" color="gray.500">Precipitation</Text>
                                    {/*<Text fontWeight="bold">{weather?.clima?.precipitacion} mm</Text>*/}
                                    <Text fontWeight="bold">
                                        {weather?.clima?.precipitacion} in
                                    </Text>

                                </Box>
                            </HStack>
                        </HStack>
                        <Box w="full">
                            <Text fontSize="sm" color="gray.500" mb={2}>Accumulated Annual Precipitation</Text>
                            {/*<Text fontSize="xl" fontWeight="bold" mb={2}>*/}
                            {/*    {weather?.clima?.precipitacionAcumulada} mm*/}
                            {/*</Text>*/}
                            <Text fontSize="xl" fontWeight="bold" mb={2}>
                                {weather?.clima?.precipitacionAcumulada} in
                            </Text>

                            <Box h="200px">
                                {weather?.datosPrecipitacion && (
                                    <LineChart
                                        data={weather.datosPrecipitacion}
                                        xKey="mes"
                                        yKey="precipitacion"
                                        color={infoColor || "#3182ce"}
                                        unit="in"
                                    />
                                )}
                            </Box>
                        </Box>

                        <HStack w="full">
                            <Icon as={FiSun} color="yellow.500" boxSize={5}/>
                            <Box>
                                <Text fontSize="sm" color="gray.500">Forecast</Text>
                                <Text fontWeight="bold">{weather?.clima?.pronostico}</Text>
                            </Box>
                        </HStack>

                        {/* Analysis Popover */}
                        <Popover.Root open={open} onOpenChange={(e) => setOpen(e.open)}>
                            <Popover.Trigger asChild>
                                <Button
                                    size="sm"
                                    variant="outline"
                                    leftIcon={<FiInfo/>}
                                    onClick={() => setOpen(!open)}
                                    loading={loadingAnalysis}
                                >
                                    Weather Analysis
                                </Button>
                            </Popover.Trigger>
                            <Portal>
                                <Popover.Positioner>
                                    <Popover.Content w="sm">
                                        <Popover.Arrow/>
                                        <Popover.Body>
                                            {weatherAnalysis ? (
                                                <Text whiteSpace="pre-wrap">{weatherAnalysis}</Text>
                                            ) : (
                                                <Text color="gray.500" fontSize="sm">There is no analysis
                                                    available.</Text>
                                            )}
                                        </Popover.Body>
                                    </Popover.Content>
                                </Popover.Positioner>
                            </Portal>
                        </Popover.Root>
                    </VStack>
                )}
            </Card.Body>
        </Card.Root>
    );
};

export default WeatherInformationE;
